// extracted by mini-css-extract-plugin
export var legendIndicator = "_g4-1";
export var legendRight = "_g4-0";